<template>
  <div>
    <common-channel @handle_select="channelChange" :props_value="form.channel"></common-channel>
    <el-date-picker
      style="margin-top:20px"
      v-model="dateArr"
      format="yyyy-MM-dd"
      type="daterange"
      value-format="yyyyMMdd"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="freshData"
    ></el-date-picker>
    <span>此日期仅供表格导出</span>
    <el-button type="primary" icon="el-icon-search" @click="exportData">导出列表</el-button>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="register_count" label="总注册量"></el-table-column>
      <el-table-column prop="enter_count" label="进入注册页面的数量"></el-table-column>
      <el-table-column prop="percent" label="注册成功数/成功率"></el-table-column>
      <el-table-column prop="pc" label="电脑网页注册人数	"></el-table-column>
      <el-table-column prop="android" label="android端注册人数"></el-table-column>
      <el-table-column prop="ios" label="ios端注册人数"></el-table-column>
      <el-table-column prop="pc_client" label="电脑客户端端注册人数"></el-table-column>

    </el-table>

    <!--分页器 -->
    <!-- <el-pagination
      @size-change="changeSize"
      @current-change="changePage"
      :current-page="page"
      :page-sizes="[20, 50, 300, 500]"
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>-->
  </div>
</template>

<script>
import { regis_total } from "@/request/api.js";
export default {
  created() {
    this.freshData();
  },
  data() {
    return {
      dateArr: [],
      tableData: [],
      page: 1, //页码
      limit: 10, //页容量
      total: 0, //总条数
      form:{
        channel:''
      }
    };
  },
  methods: {
    freshData() {
      let params = {
        ...this.form
      }
      if(this.dateArr && this.dateArr[0]){
        params.start_date = this.dateArr[0]
        params.end_date = this.dateArr[1]
      }
      regis_total(params).then(res => {
        if (res.status == 0) {
          this.$message.success("获取成功");
          res.detail.forEach((item,idx)=>{
            item.index =res.total-(this.page-1)*this.limit - idx
            item.register_count = (item.pc + item.android + item.ios +item.pc_client) || 0
          })
          this.tableData = res.detail;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    changeSize(val) {
      this.limit = val;
      this.freshData();
    },
    changePage(val) {
      this.page = val;
      this.freshData();
    },
    //表格导出
    exportData() {

    },
    channelChange(val){
      this.form.channel = val 
      this.freshData()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-helper {
  margin-bottom: 20px;
}
>>> .el-table th {
  user-select: text;
}
</style>
